export const searchReservationsFieldNames: any = {
  start_time: 'start_time',
  end_time: 'end_time',
  reservation_id: 'reservation_id',
  guest_name: 'guest_name',
  phone: 'guest_phone',
  company: 'guest_company',
  email: 'guest_email',
};
